import Vue from "vue";
import dayjs from "dayjs";

dayjs.locale("zh-cn");
Vue.prototype.$dayjs = dayjs;



// WEBPACK FOOTER //
// ./src/plugins/dayjs.js